import React from 'react';
import { Table } from 'antd';
import './style.scss';

const TableComponent = ({ columns, dataSource, className, bordered = true, rowKey, title, pagination, footer, onChange, loading, rowClassName, ...rest }) => {
	return (
		<Table
			{...{
				loading,
				className: `table-component ${className}`,
				// columns: loading
				// 	? columns.map((column) => {
				// 			return {
				// 				...column,
				// 				render: function renderPlaceholder() {
				// 					return <Skeleton key={column.dataIndex} title={true} active paragraph={false} style={{ width: '100%' }} />;
				// 				},
				// 			};
				// 	  })
				// 	: columns,
				// bordered,
				columns,
				dataSource,
				rowKey,
				title,
				pagination,
				footer,
				onChange,
				rowClassName,
				...rest,
			}}
		/>
	);
};

export default TableComponent;
